import { Dispatch, SetStateAction, createContext } from "react";

export const initState = {
  disableHotkey: false,
  setDisableHotkey: () => {},
};

export type DisableHotkeyContextState = {
  disableHotkey: boolean;
  setDisableHotkey: Dispatch<SetStateAction<boolean>>;
};

const DisableHotkeyContext = createContext<DisableHotkeyContextState>(initState);

export default DisableHotkeyContext;
